import {
  ModelConceptHierarchy,
  ModelConceptHierarchyLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import {
  isModelConceptHierarchy,
  isModelConceptHierarchyLabel,
} from 'src/containers/ProjectDiagram/utils/data';

export const getPreviousHierarchyConnection = (
  diagram: DiagramSnapshot,
  data: ModelConceptHierarchy | ModelConceptHierarchyLabel
) => {
  if (isModelConceptHierarchy(data)) {
    return diagram.model.modelData.draftData?.prevLinkDataArray.find(
      (linkData): linkData is ModelConceptHierarchy =>
        isModelConceptHierarchy(linkData) && linkData.key === data.key
    );
  }

  if (isModelConceptHierarchyLabel(data)) {
    return diagram.model.modelData.draftData?.prevNodeDataArray.find(
      (nodeData): nodeData is ModelConceptHierarchyLabel =>
        isModelConceptHierarchyLabel(nodeData) && nodeData.key === data.key
    );
  }

  return undefined;
};
